//支付跳转封装 qr:二维码支付
import router from '@/router/router'
import {isPayToNewWindow} from 'meibao-insure/src/util/productUtil'
import {getStore, setStore} from '@/util/store'
import {getPayStatus} from '@/api/insurance/policy'
import {validatenull} from '@/util/validate'
import {Message, MessageBox} from 'element-ui'
import {EnumInsureUrlType} from '@/const/enum'

export function payToHint(payData = {}) {
	let {payOrderId, payUrl, payType, insureType, orderId = ''} = payData
	if (payType !== 'qr' && !isPayToNewWindow(insureType)) {
		//不是二维码 部分险种，直接跳转
		window.open(payUrl, '_blank')
	} else {
		setStore({name: payOrderId, content: {payUrl, payType, orderId}, type: 'session'})
		// //跳转界面
		router
			.push({
				path: router.$avueRouter.getPath({
					src: `/policy/pay/${payOrderId}`,
				}),
			})
			.then(() => {})
	}
}

let resultTimer = null
let isPayStatusLoading = false

//支付结果轮询
export function getPayResult(payData) {
	let {payOrderId, orderId} = payData
	resultTimer = setInterval(async () => {
		if (!isPayStatusLoading) {
			isPayStatusLoading = true
			let res =
				(await getPayStatus(payOrderId).catch(() => {
					isPayStatusLoading = false
				})) || {}
			let {code = -1} = res.data || {}
			isPayStatusLoading = false
			if (code === 0) {
				//清除轮询
				clearIntervalPay()
				//成功
				Message.success('支付成功')
				//查询是否有佣金券
				let couponList = await getMatchCouponTicketList(payData)
				//当前有可用佣金券
				if (couponList.length > 0) {
					//筛选
					MessageBox.confirm('您有未使用的佣金券，是否前往使用？', '提示', {
						confirmButtonText: '立即使用',
						showCancelButton: true,
					})
						.then(() => {
							//跳转佣金券
							router.push({
								path: '/coupon/front/index',
							})
						})
						.catch((e) => {
							//不使用
							payOverToPath(orderId)
						})
				} else {
					//直接关闭
					payOverToPath(orderId)
				}
			}
		}
	}, 3000)
}

//支付后跳转逻辑
function payOverToPath(orderId) {
	//直接关闭
	router.$avueRouter.closeTag()
	//跳转类别 1是从列表过来的
	let src = orderId === '1' ? '/insurance/policy/index' : `/policy/details/${orderId}`
	router
		.push({
			path: router.$avueRouter.getPath({
				src,
			}),
		})
		.then(() => {})
}

export function clearIntervalPay() {
	if (!validatenull(resultTimer)) {
		clearInterval(resultTimer)
		resultTimer = null
	}
}

/**
 * 封装跳转至投保界面！！
 * @param queryData 请求数据,
 * 类型，insure 投保， change 批改, add 批增
 *
 * 重点！！！！！ 如果是批增进入的，直接判断当前保单的数据
 */
export async function toInsureCenter(queryData = {}) {
	//获取缓存的
	let brokerInfo = getStore({name: 'brokerInfo'}) || {}
	//合并
	let tempQueryData = Object.assign({}, queryData, brokerInfo)
	console.log('tempQueryData-------', tempQueryData)
	//通过接口判断，或者通过保单数据判断！！！！！！！！
	let {flag = 0, sourceProductId, orderId = '', fromType = EnumInsureUrlType.insure} = tempQueryData
	//默认投保！
	if (fromType === EnumInsureUrlType.insure || validatenull(fromType)) {
		tempQueryData.fromType = EnumInsureUrlType.insure
	}
	let tempSrc = ''
	//跳转路径
	// flag	是否切换域名（1：是 2：否）
	if (flag === 2) {
		//不跳转域名！！
		if (tempQueryData.host) {
			delete tempQueryData.host
		}
		switch (fromType) {
			case EnumInsureUrlType.insure:
			//投保
			case EnumInsureUrlType.add:
				//批增
				tempSrc = `/insuranceCenter/entryCenter/${sourceProductId}`
				break
			case EnumInsureUrlType.change:
				// 替换
				tempSrc = `/policy/endorseReplace/${orderId}`
				break
			case EnumInsureUrlType.addInsured:
			case EnumInsureUrlType.editSingleInsured:
				//新增被保人
				tempSrc = `/policy/insured/${fromType}/${orderId}`
				break
			case EnumInsureUrlType.addMoreInsured:
			case EnumInsureUrlType.editMoreInsured:
				//批量被保险人
				tempSrc = `/policy/insured/${fromType}/${orderId}`
				break
			case EnumInsureUrlType.detail:
				//详情
				tempSrc = `/policy/details/${orderId}`
				break
			case EnumInsureUrlType.pay:
				//支付
				tempSrc = `/insuranceCenter/pay/payOffline`
				break
			case EnumInsureUrlType.policyList:
				//保单列表
				tempSrc = `/insurance/policy/index`
				break
		}
	} else {
		//跳转域名！！
		let lastKey = ''
		//通过URL投保
		switch (fromType) {
			case EnumInsureUrlType.insure:
			case EnumInsureUrlType.add:
				//投保 批增
				lastKey = sourceProductId
				break
			case EnumInsureUrlType.change:
			//新增 修改被保人
			case EnumInsureUrlType.addInsured:
			case EnumInsureUrlType.editSingleInsured:
			//批量被保险人
			case EnumInsureUrlType.addMoreInsured:
			case EnumInsureUrlType.editMoreInsured:
				lastKey = orderId
				break
		}
		if (!lastKey) {
			MessageBox.alert('lastKey：跳转路径有误！').then(() => {})
			return
		}
		tempSrc = `/insuranceCenter/entryCenterUrl/${fromType}/${lastKey}`
	}
	//
	// //如果是新投保，则直接判断产品库数据
	// if (fromType === EnumInsureUrlType.insure) {
	//   tempQueryData.fromType = EnumInsureUrlType.insure
	//   //新投保 只有新投保才会校验是否通过URL投保
	//   //通过接口判断是否需要用URL投保
	//   let resList = await fetchList({size: 999}) || {}
	//   let {code = -1, data: {records = []} = {}} = resList.data
	//   if (code !== 0) {
	//     return
	//   }
	//   //通过records里查询 id是否匹配 sourceProductId
	//   let tempProduct = records.find(({productPlanRelationList = [], productId = ''}) => {
	//       //判断当前产品是否匹配
	//       return `${productId}` === `${sourceProductId}` || productPlanRelationList.findIndex(({planId = ''}) => `${sourceProductId}` === `${planId}`) >= 0
	//     },
	//   )
	//   if (!tempProduct) {
	//     Message.error('产品数据有误！')
	//     return
	//   }
	//   //1全部  2：否   3：PC   4：小程序 默认 2
	//   let {insureByUrl = '-1'} = tempProduct
	//   console.log('insureByUrl-------', tempProduct, insureByUrl)
	//   if (insureByUrl === '1' || insureByUrl === '3') {
	//     //通过URL投保
	//     tempSrc = `/insuranceCenter/entryCenterUrl/insure/${sourceProductId}`
	//   } else {
	//     tempSrc = `/insuranceCenter/entryCenter/${sourceProductId}`
	//   }
	// } else {
	//   //如果是其他批改，则判断当前保单数据
	//   if (isPolicyByUrl(testtest)) {
	//     //通过URL投保
	//     switch (fromType) {
	//       //批增 替换
	//       case EnumInsureUrlType.add:
	//       case EnumInsureUrlType.change:
	//       //新增 修改被保人
	//       case EnumInsureUrlType.addInsured:
	//       case EnumInsureUrlType.editSingleInsured:
	//       //批量被保险人
	//       case EnumInsureUrlType.addMoreInsured:
	//       case EnumInsureUrlType.editMoreInsured:
	//         tempSrc = `/insuranceCenter/entryCenterUrl/${fromType}/${orderId}`
	//         break
	//     }
	//   } else {
	//     switch (fromType) {
	//       case EnumInsureUrlType.add:
	//         //批增
	//         tempSrc = `/insuranceCenter/entryCenter/${sourceProductId}`
	//         break
	//       case EnumInsureUrlType.change:
	//         // 替换
	//         tempSrc = `/policy/endorseReplace/${orderId}`
	//         break
	//       case EnumInsureUrlType.addInsured:
	//       case EnumInsureUrlType.editSingleInsured:
	//         //新增被保人
	//         tempSrc = `/policy/insured/${fromType}/${orderId}`
	//         break
	//       case EnumInsureUrlType.addMoreInsured:
	//       case EnumInsureUrlType.editMoreInsured:
	//         //批量被保险人
	//         tempSrc = `/policy/insured/${fromType}/${orderId}`
	//         break
	//     }
	//   }
	// }
	router
		.push({
			path: router.$avueRouter.getPath({
				src: tempSrc,
			}),
			query: tempQueryData,
		})
		.then(() => {})
		.catch((e) => {
			MessageBox.alert(e.message || '页面跳转失败，请稍后再试', '提示').then(() => {})
		})
}
